import { z } from 'zod';
import { defineEndpoint } from '../define';

/**
 * Live updates for the runner monitor (text/event-stream, not JSON). Emits a bare
 * `event: changed` whenever a sample, job event or GitHub sync writes runner data;
 * the client then refetches. Heartbeat comments keep proxies from idling out.
 */
export const runnerMonitorEventsStream = defineEndpoint({
  method: 'GET',
  path: '/v1/runner-monitor/events',
  params: z.object({}),
  query: z.object({}),
  body: z.undefined(),
  response: z.undefined(),
});
